module.exports = __webpack_public_path__ + "static/media/02-12.0ba7a33e.png";